import React from 'react';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import "../css/footer.css";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

const ContactBanner = ({ heading, paragraph,backgroundImage}) => (
  <div className='contact-banner'
  style={{
    background: `
      linear-gradient(to bottom, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.9)),
      url(${backgroundImage}) center/cover no-repeat
    `,
  }}
  >
    <div className='contact-content'>
      <h1>{heading}</h1>
      <p>{paragraph}</p>
    </div>
  </div>
);

const Footer = ({ data }) => {
  if (!data) return null;

  return (
    <>
      <ContactBanner heading={data.banner_heading} 
      paragraph={data.banner_paragraph} 
      backgroundImage={data.footer_img}/>

      <div className='footer'>
        <div className='footer-container'>
          <div className='footer-column'>
            <h3>{data.heading_one}</h3>
            <ul>
              <li><Link to="/">{data.link_home_text}</Link></li>
              <li><Link to="/aboutus">{data.link_aboutus_text}</Link></li>
              <li><Link to="/careers">{data.link_careers_text}</Link></li>
              <li><Link to="/login">{data.link_signin_text}</Link></li>
              <li><Link to="/contact">{data.link_contact_text}</Link></li>
            </ul>
          </div>

          <div className='footer-column'>
            <h3>{data.heading_two}</h3>
            <div className="footer-contact">
              <FaPhoneAlt className="icon" />
              <span>{data.phone_number}</span>
            </div>
            <div className="footer-contact">
              <FaEnvelope className="icon" />
              <span>{data.email_address}</span>
            </div>
            <div className="footer-contact">
              <FaMapMarkerAlt className="icon" />
              <span>{data.office_address}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  data: state.footer.data,
});

export default connect(mapStateToProps)(Footer);

